import { useButtonUpdateStore } from "@/stores/buttonUpdateStore"
import { useMobileRouterStore } from '@/stores/mobileRouterStore'
import { useComponentTreeStore } from '@/stores/componentTreeStore'
import { getDetailApi } from "@/api/dataset/dataset-sql";
import { executeSelectKey } from "@/api/sql-execute-api";
import { getURLParam } from '@/utils/jsfunction-handler'
import { execSqlData, logicEngineRun } from '@/api/api-bladex'
import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
import { FuncEventConfig } from '@/utils/functionEvent'
import { setObj } from "@/utils/object-method";
import componentOptions from '@/components/options';
import { finArrChildrenValue } from '@/utils/func.js';
import { reactive } from "vue";
import { fileUrl } from '/env'


/**
 * @title 更新与保存
 */
export class ButtonUpdate {
    static buttons = ['button-update', 'button-delete']

    static verifyEventConfig(item) {
        try {
            return this.buttons.some(type => item.cptType?.includes(type))
        } catch (error) {
            return false
        }
    }
    static verifyStaticUpdate(item) {
        try {
            return this.buttons.some(type => item.cptType?.includes('button-update'))
        } catch (error) {
            return false
        }
    }
    static verifyStaticDelete(item) {
        try {
            return this.buttons.some(type => item.cptType?.includes('button-delete'))
        } catch (error) {
            return false
        }
    }
    // 
    static titleConfig(item) {
        let title = ['保存&更新', '删除']
        try {
            let index = this.buttons.findIndex(type => item.cptType?.includes(type))
            // 配置
            return index !== -1 ? `${title[index]}配置` : ''
        } catch (error) {
            return false
        }
    }
    static verifyDialogOpenConfig({ intType, tips, currentCpt }, callback) {
        let eventIndex = currentCpt.cptOption.interaction.eventList.findIndex(item => item.intType === intType)
        if (eventIndex == -1) {
            callback && callback()
        } else {
            const confirmDia = DialogPlugin({
                header: '事件提示',
                body: `此操作将会删除绑定的${tips}事件，是否继续?`,
                className: 't-dialog-new-class1 t-dialog-new-class2',
                style: 'color: rgba(0, 0, 0, 0.6)',
                onConfirm: () => {
                    // this.myDialog.hide();
                    currentCpt.cptOption.interaction.eventList.splice(eventIndex, 1)
                    // refMap['cptStaticBackFillConfig'].opened(currentCpt, refMap)
                    callback && callback()
                    confirmDia.destroy()
                },
                onClose: ({ e, trigger }) => {
                    confirmDia.hide();
                },
            });
        }

    }
    // 打开弹窗
    static openConfig(refMap, currentCpt, type) {
        try {
            if (type === 'update-static') {
                // 静态回填配置
                // let params = { intType: 'buttonUpdate-static', tips: '[静态回填配置]', currentCpt }
                refMap['cptStaticBackFillConfig'].opened(currentCpt, refMap)
                // this.verifyDialogOpenConfig(params, () => {
                // })
                return
            } else if (type === 'delete-static') {
                // 静态删除
                // let params = { intType: 'buttonStatic-delete', tips: '[静态删除配置]', currentCpt }
                refMap['cptStaticDeleteConfig'].opened(currentCpt, refMap)
                // this.verifyDialogOpenConfig(params, () => {
                // })
                return

            } else if (type === 'button-update' || currentCpt.cptType == 'button-update') {
                // let params = { intType: 'buttonUpdate', tips: '[保存&更新配置]', currentCpt }
                refMap['cptButtonUpdateConfig'].opened(currentCpt, refMap)

                return

            } else if (type === 'button-delete' || currentCpt.cptType == 'button-delete') {
                // let params = { intType: 'buttonDelete', tips: '[删除配置]', currentCpt }
                refMap['cptButtonDeleteConfig'].opened(currentCpt, refMap)

                return

            } else {
                // let params = {}
                // switch (currentCpt.cptType) {
                //     case 'button-delete':
                //         // params = { intType: 'buttonDelete', tips: '[删除配置]', currentCpt }
                //         refMap['cptButtonDeleteConfig'].opened(currentCpt, refMap)
                //         // this.verifyDialogOpenConfig(params, () => {
                //         // })
                //         break;
                //     case 'button-update':
                //         // params = { intType: 'buttonUpdate', tips: '[保存&更新配置]', currentCpt }
                //         refMap['cptButtonUpdateConfig'].opened(currentCpt, refMap)
                //         // this.verifyDialogOpenConfig(params, () => {
                //         // })
                //         break;
                //     default:
                //         break;
                // }

            }
        } catch (error) {
            throw error
        }

    }
    // 执行代码
    static async executionCode({ eventItem, refMap, exeEvent }, { router }, callFn = null) {
        const buttonUpdateStore = useButtonUpdateStore()

        const store = useButtonUpdateStore()
        const event = eventItem.eventFunction
        const list = store.tableList

        sessionStorage.setItem('componentsNumber', 1)

        let results = {}
        let shouldContinue = true;
        for (const key of list) {
            if (typeof this[key.event] === 'function' && shouldContinue) {
                try {
                    const result = await this[key.event]({
                        eventItem,
                        event: event[key.event],
                        results: results,
                        refs: refMap,
                        exeEvent,
                        buttonUpdateStore
                    }, { router });
                    results[`${key.event}Results`] = result
                    console.log(results, 'resultresultresult');
                    if (result === false) { // 根据你的实际逻辑判断是否应该停止
                        shouldContinue = false;
                        break;
                    }
                } catch (error) {
                    shouldContinue = false;
                    console.error(error);
                    break;
                }
            }
        }
        if (callFn) { callFn() };

    }
    /**
     * 保存
     * @param {*} param0 
     * @returns 
     */
    static async saveConfig({ eventItem, event, results, refs, buttonUpdateStore }) {
        let verifyExec = false
        const newDataTable = JSON.parse(JSON.stringify(event.table))
        const buttonId = eventItem.buttonUpdateId
        // 处理字段配置数据
        // const primaryKey = this.getPrimaryKey(refs, buttonId).value

        let newData = newDataTable.map(item => {
            item.paramsList = this.paramListHandler(item.paramsList, refs, item, buttonId)

            verifyExec = item.paramsList.find(c => c?.type && c?.type == 'NOTEXEC')

            return item
        })
        if (verifyExec) {
            MessagePlugin.error(verifyExec.message)
            console.log('发送保存与更新失败：参数校验失败')
            return false
        }


        // 设置主表
        const mainTable = this.setMainTableData({ mainItem: newData[0], refs, buttonId })

        // 设置子表
        let childList = newData.splice(1)
        let childTable = []
        console.log(childList, newDataTable, event, 'childListchildList');
        for (let i = 0; i < childList.length; i++) {
            const childItem = childList[i];
            let table = this.setChildTableData({ childItem, refs, buttonId, mainTable })
            childTable.push(...table)
        }

        // 存储主表信息


        let params = [mainTable, ...childTable]
        console.log(buttonUpdateStore, 'buttonUpdateStore');
        buttonUpdateStore.setSaveConfigMainTableInfo(mainTable)

        console.log('保存&更新拼装数据：', params)


        const result = await execSqlData({
            datasourceId: event.table[0].dataSrouceId,
            param: params
        })

        console.log(mainTable, 'asdasdasdasdasasdasd');

        if (result.code === 200 && result.success) {
            return result
        } else {
            return false
        }

    }
    /**
     * 设置主表组装数据
     * @param {*} param0 
     * @returns 
     */
    static setMainTableData({ mainItem, refs, buttonId }) {
        let field = {}
        let format = {}

        // 获取主键
        const { value, flag } = this.getPrimaryKey({
            refs, buttonId,
            keyValue: mainItem.primaryKeyValue,
            keyType: mainItem.primaryKeyType,
        })

        if (mainItem?.paramsList.length) {
            for (let i = 0; i < mainItem.paramsList.length; i++) {
                let formatObj = {}
                let { paramName, paramValue, paramDateType, paramType } = mainItem.paramsList[i]
                if (paramDateType) {
                    format[paramName] = paramDateType
                }
                if (paramValue === 'getPrimaryKey') {
                    field[paramName] = value
                } else {
                    field[paramName] = paramValue
                }
            }
        }

        field[mainItem.primaryKey] = value
        field['primaryKey'] = mainItem.primaryKey
        field['flag'] = flag
        field['format'] = [format]
        field['table'] = mainItem.tableName

        return field
    }
    /**
    * 设置子表组装数据
    * @param {*} param0 
    * @returns 
    */
    static setChildTableData({ childItem, refs, buttonId, mainTable }) {
        if (!childItem?.filterSqlNinegrid) {
            return {}
        }
        let ninegrid = refs[childItem?.filterSqlNinegrid]
        let ninegrid_tableData = ninegrid.tableData

        let table = ninegrid_tableData.map(item => {
            let field = {}
            let format = {}
            if (childItem?.paramsList.length) {
                for (let i = 0; i < childItem.paramsList.length; i++) {
                    let { paramName, paramValue, paramDateType, paramType } = childItem.paramsList[i]
                    console.log(childItem.paramsList[i], item, 'childItem.paramsList[i]');
                    if (paramDateType) {
                        format[paramName] = paramDateType
                    }
                    if (paramType === 'sql') {
                        paramValue = item[paramValue]
                    }
                    field[paramName] = paramValue
                }
            }
            // 子表外键
            field[childItem.tableFieldOutName] = mainTable[mainTable.primaryKey]
            // 子表主键id
            field['primaryKey'] = childItem.primaryKey
            // field[childItem.primaryKey] = item[childItem.primaryKey]
            // field['flag'] = item.flag
            field['format'] = [format]
            field['table'] = childItem.tableName

            // 子表的flag和主键id根据主表来
            field['flag'] = mainTable.flag
            // 获取主键
            // const { value, flag } = this.getPrimaryKey({
            //     refs, buttonId,
            //     keyValue: item.primaryKey,
            //     keyType: mainItem.primaryKeyType,
            // })
            field[childItem.primaryKey] = this.generate32BitValue()

            console.log(mainTable, 'mainTablemainTable');

            console.log(childItem, item, field, 'qdwojiqwojdiqwiddijwqjid')

            return field
        })

        return table

        // 获取主键
        // const { value, flag } = this.getPrimaryKey({
        //     refs, buttonId,
        //     keyValue: childItem[0].primaryKeyValue,
        //     keyType: childItem[0].primaryKeyType,
        // })
        // field[item.primaryKey] = value
        // field['primaryKey'] = item.primaryKey
        // field['flag'] = flag
        // field['format'] = [format]
        // field['table'] = item.tableName

        // return field
    }

    // 校验
    static async verifyConfig({ event, refs }) {
        console.log('save verifyConfig', event)
        if (!event.apiId) {
            return
        }
        let verifyExec = false
        const paramDataJson = JSON.parse(JSON.stringify(event.paramData))
        const paramResult = this.paramListHandler(paramDataJson, refs)
        verifyExec = paramResult.find(c => c?.type && c?.type == 'NOTEXEC')
        if (verifyExec) {
            MessagePlugin.error(verifyExec.message)
            console.log('发送保存与更新失败：参数校验失败')
            return false
        }


        console.log(paramResult, 'paramResultparamResultparamResult')
        let param = {}
        paramResult.forEach(item => {
            param[item.paramName] = item.paramValue
        })
        console.log(param, 'asjdasiodaisodiasdsiad??????????')
        try {
            const result = await logicEngineRun(event.apiId, param)
            // 处理返回数据

            // this.messageConfig({ event, result })
            console.log(result.data)
            return result.data
        } catch (error) {
            console.log(error, 'errorerrorerror')
            console.error('执行逻辑编排失败:', error)
            return {
                success: false,
                message: error
            }
        }

    }
    // 消息
    static messageConfig({ event, results }) {
        console.log('messageConfig', event, results)

        let res = results.saveConfigResults ? results.saveConfigResults : results.verifyConfigResults
        if (!res) {
            res = results.deleteConfigResults
        }
        console.log(res, event, 'xiaoxjiadjiasdajisdiasi')
        if (!event.isMessage) {
            return
        }
        console.log(res, 'qwdiojqdqiodqdioqioq');
        if (res && res.success) {
            let msg = event.successMessage.length ? event.successMessage : res?.msg
            if (event.messageType === 'tip') {
                MessagePlugin.success({ content: msg })
            } else {
                this.messagePopup({ body: msg, theme: 'success' })
            }

        } else {
            let msg = event.errorMessage.length ? event.errorMessage : res?.msg
            if (res?.success == false && msg.length) {
                if (event.messageType === 'tip') {
                    MessagePlugin.error({ content: msg })
                } else {
                    this.messagePopup({ body: msg, theme: 'danger' })

                }
            }
        }
    }
    // 消息弹窗
    static messagePopup({ body, theme }) {
        const alertDia = DialogPlugin.alert({
            header: '提示',
            body,
            theme,
            confirmBtn: {
                content: '确定',
                variant: 'base',
                theme,
            },
            onConfirm: ({ e }) => {
                console.log('confirm e: ', e);
                alertDia.hide();
            },
            onClose: ({ e, trigger }) => {
                console.log('close e: ', e);
                console.log('trigger: ', trigger);
                alertDia.hide();
            },
        });
    }
    // 跳转
    static jumpConfig({ event, refs, exeEvent, eventItem }, { router }) {
        console.log('jumpConfig', event)
        if (!event?.routerType) {
            return
        }

        let data = JSON.parse(JSON.stringify(event))
        let newData = this.paramListHandler(data.paramData, refs)
        const mobileStore = useMobileRouterStore()
        let ninegrid = this.getNinegrid(refs, eventItem.buttonUpdateId)
        //关闭弹窗
        if (ninegrid) {
            ninegrid.hidePop && ninegrid.hidePop()
        }

        if (data.routerType === 'to') {
            console.log(exeEvent, 'exeEvent')
            exeEvent.func(...exeEvent.params)
        } else if (data.routerType === 'goBack') {
            if (WeChat.verifyWx()) {
                WeChat.goBack({
                    delta: 1,
                    data: {
                        reload: true
                    }
                })
            } else if (location.href.includes('/mobile')) {
                let currentPage = mobileStore.historyPageList[mobileStore.historyPageList.length - 2]
                mobileStore.setCurrentPage(currentPage)
                mobileStore.resetLocationUrl(currentPage)
                mobileStore.setHistoryPageList(currentPage)
                mobileStore.removeHistoryPageList(currentPage.id)
            } else {
                // router.go(-1)
            }
        } else if (data.routerType === 'reload') {
            location.reload()
            // if (!ninegrid || !ninegrid.current) {
            //     return
            // }
            // let fId = ninegrid.current.cptOption.interaction.popData.fatherGridId
            // let fatherGridId = refs[fId]
            // if (!fatherGridId) {
            //     return
            // }
            // let cptDataForm = fatherGridId.current.cptOption.cptDataForm
            // fatherGridId.reloadCptData(cptDataForm, true)
            // console.log(ninegrid, 'ninegrid.current')

        }



    }
    // 回填
    static backFillConfig({ event, results, eventItem, refs }) {
        console.log('backFillConfig', event)

        if (!event.paramData.length) {
            return
        }
        let obj = {}
        let gridNumber = null

        obj = this.assemblyData(event.paramData, refs)

        let ninegrid = this.getNinegrid(refs, eventItem.buttonUpdateId)
        if (ninegrid && ninegrid?.obj?.fatherGridId) {
            // 行索引
            gridNumber = ninegrid.obj.gridNumber

            // 调用九宫格回填方法
            refs[ninegrid.obj.fatherGridId].gridStaticBackfill({ gridNumber, obj })
        } else {
            // 其他回填 - 通过compId回填
            // if (event.paramData) {
            //     for (let i = 0; i < event.paramData.length; i++) {
            //         const item = event.paramData[i];
            //         // let to = refs[item.to]
            //         let target = refs[item.target]
            //         console.log(target,'cao')
            //         // to.setValue(target.getValue())

            //     }
            // }
        }


    }
    // 组装数据
    static assemblyData(paramData, refs) {
        let obj = {}
        console.log(paramData, 'paramData')
        for (let i = 0; i < paramData.length; i++) {
            const paramItem = paramData[i];

            let target = refs[paramItem.target]

            if (target && target.current && paramItem.to) {
                let value = target.getValue()
                obj[paramItem.to] = value
            }
        }
        return obj
    }
    // 处理字段配置数据
    static paramListHandler(list, refMap, tableItem, control) {
        let dateTypeArray = {
            'year': 'yyyy',
            'month': 'yyyy-mm',
            'date': 'yyyy-mm-dd',
            'datetime': 'yyyy-mm-dd HH24:MI:SS',
        }

        let newList = list.map((item, index) => {
            console.log(item, 'qwdowqodqowdkdokqdowqdokqwdokok');
            switch (item.paramType) {
                case 'control': // 控件值获取
                    try {
                        // 处理日期
                        let control = refMap[item.paramValue]?.current

                        let isDatePicker = control && (control.cptKey === "cpt-date-picker" || control.cptKey === 'cpt-date-picker-mobile')
                        if (isDatePicker) {
                            let type = control.cptOption.attribute.dateFormat

                            if (dateTypeArray[type]) {
                                item.paramDateType = dateTypeArray[type] 
                            }
                        }
                        // 校验
                        const controlCheckFunc = refMap[item.paramValue]?.checkValue
                        console.log(refMap[item.paramValue],'qwdokjqwidjqwidjiqwdiodijoqw')
                        const controlCheckVal = refMap[item.paramValue]?.current?.cptOption?.attribute?.required
                        if (controlCheckVal && controlCheckFunc && !controlCheckFunc()) {
                            return {
                                type: 'NOTEXEC',
                                message: refMap[item.paramValue].tips
                            }
                        }
                        console.log(refMap[item.paramValue],'qwdio0jwqio0doqwdijoqdwiio')
                        let value = refMap[item.paramValue].getValue()
                        item.paramValue = value

                    } catch (error) {
                        console.error('getComponentValue: not found getValue()', error)
                    }
                    break;
                case 'url': // 通过url获取值
                    item.paramValue = getURLParam(item.paramName)
                    break;
                case 'function': // 通过函数获取值
                    try {
                        // 函数返回值
                        const eventValue = FuncEventConfig.config[item.paramValue].exec()

                        // 日期格式处理
                        const isDate = GetDate.isValidDate(eventValue)
                        if (isDate) {
                            item.paramDateType = dateTypeArray['datetime']
                        }



                        item.paramValue = eventValue
                    } catch (error) {
                        console.error('函数获取值失败：', error)
                    }
                    break

                default:
                    break;
            }

            return item
        })
        console.log(newList, 'iajsdiasidaijasdidji')
        return newList
    }
    // 设置businessId
    static setBusinessId(primaryKey) {
        let businessId = getURLParam('businessId')
        if (!businessId) {
            let getSearch = location.search?.includes('?')
            let or = getSearch ? '&' : '?'
            window.history.pushState({}, '', `${location.pathname}${or}businessId=${primaryKey}`)
        }
    }
    // 获取主键
    static getPrimaryKey({ refs, buttonId, keyValue, keyType }) {
        console.log('getPrimaryKey')
        let ninegrid = this.getNinegrid(refs, buttonId)
        let insertData = {
            flag: 'insert',
            value: this.generate32BitValue()
        }
        console.log(keyType, 'keyTypekeyType', keyValue)
        switch (keyType) {
            case 'popup':
                let popupValue = ninegrid.obj.eventItem.paramsIds.find(x => x.paraName === keyValue)
                console.log(popupValue, ninegrid, keyValue, 'wpocaocaocaooaco')
                if (ninegrid.obj.eventItem.backFuc === 'jing') {
                    // 静态
                    let ninegridRowData = ninegrid.obj.curRowData
                    if (ninegridRowData && ninegridRowData[keyValue]) {
                        return {
                            flag: 'update',
                            value: ninegridRowData[keyValue]
                        }
                    } else {
                        console.error('not find sql id')
                        return insertData
                    }

                } else {
                    // 动态
                    if (popupValue) {
                        return {
                            flag: 'update',
                            value: popupValue.val
                        }
                    } else {
                        console.error('not find popup id ')
                        return insertData
                    }
                }
                break;
            case 'ninegrid':
                let ninegridRowData = ninegrid.obj.curRowData
                if (ninegridRowData && ninegridRowData[keyValue]) {
                    return {
                        flag: 'update',
                        value: ninegridRowData[keyValue]
                    }
                } else {
                    console.error('not find sql id')
                    return insertData
                }
                break;
            case 'url':
                let urlValue = keyValue && getURLParam(keyValue)
                console.log(urlValue, 'getPrimaryKeygetPrimaryKey ')
                let isNumber = Number(urlValue)
                if (urlValue && isNumber !== 'NaN') {
                    return {
                        flag: 'update',
                        value: urlValue
                    }
                } else {
                    console.log('getPrimaryKey: not find url id ')
                    return insertData
                }
                break;
            default:
                console.log('default')
                return insertData
                break;
        }

    }
    static getNinegrid(refs, buttonId) {
        let isTrue = false
        for (const key in refs) {
            let cptKey = refs[key]?.current?.cptKey
            if (cptKey === 'cpt-ninegrid') {
                let ninegrid = refs[key].current?.tabGroup
                for (const cKey in ninegrid) {
                    if (ninegrid[cKey]?.includes(buttonId)) {
                        isTrue = refs[key]
                    }
                }
            }
        }
        return isTrue
    }
    // 生成32位businessId
    static generate32BitValue() {
        // 获取当前时间戳（单位：毫秒）
        const random = this.generateRandom19DigitNumberString()

        return random.toString()
    }
    // 生成19位随机数
    static generateRandom19DigitNumberString() {

        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1)
        const day = date.getDay() < 10 ? `0${date.getDay()}` : date.getDay()
        const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()


        const dateString = `${year}${month}${day}${hour}${minutes}${seconds}`

        const min = Math.pow(10, 9); // 最小值为 10^9
        const max = Math.pow(10, 10) - 1; // 最大值为 10^10 - 1

        // Math.random() 生成 [0, 1) 之间的随机数
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;



        return dateString + randomNumber



        return
        // 创建一个19位最大值的大整数
        const maxBigInt = BigInt('9' + '0'.repeat(18));
        const minBigInt = BigInt(1); // 最小值为1，保证生成的数至少是19位

        // 使用Crypto API生成更安全的随机数（适用于支持Web Crypto API的环境）
        if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
            const array = new Uint8Array(19);
            window.crypto.getRandomValues(array);
            let randomBigInt = BigInt(0);
            for (let i = 0; i < array.length; ++i) {
                randomBigInt = (randomBigInt << 8n) + BigInt(array[i]);
            }
            randomBigInt += minBigInt;
            if (randomBigInt > maxBigInt) {
                randomBigInt %= (maxBigInt - minBigInt + BigInt(1));
            }
            return randomBigInt.toString();
        }
        // 或者使用Math.random()配合BigInt（非加密安全）
        else {
            do {
                let randomBigInt = BigInt(Math.floor(Math.random() * Number(maxBigInt - minBigInt))) + minBigInt;
                if (randomBigInt.toString().length >= 19) {
                    return randomBigInt.toString();
                }
            } while (true);
        }
    }
    static backDataHandler(result) {
        if (Array.isArray(result)) {
            return result
        } else if (Object.prototype.toString.call(result) === '[object Object]') {
            return [result]
        } else {
            return [result]
        }
    }

}
/**
 * @title 删除
 */
export class ButtonDelete {
    static async executionCode({ eventItem, refMap, exeEvent }, { router }, callFn = null) {
        console.log('ButtonDelete exec')
        const store = useButtonUpdateStore()
        const event = eventItem.eventFunction
        const list = store.deleteList

        let results = []
        let shouldContinue = true;
        for (const key of list) {
            if (typeof this[key.event] === 'function' && shouldContinue) {
                try {
                    const result = await this[key.event]({
                        eventItem,
                        event: event[key.event],
                        results: results,
                        refs: refMap,
                        exeEvent
                    }, { router });
                    // results.push(result)
                    results[`${key.event}Results`] = result
                    console.log(results, 'resultsresultsresults');
                    if (result === false) { // 根据你的实际逻辑判断是否应该停止
                        shouldContinue = false;
                        break;
                    }
                } catch (error) {
                    shouldContinue = false;
                    console.error(error);
                    break;
                }
            }
        }
        if (callFn) { callFn() }

    }

    static verifyConfig() {
        console.log('ButtonDelete verifyConfig')
        return ButtonUpdate.verifyConfig(...arguments)
    }
    static async deleteConfig({ eventItem, event, results, refs }) {

        const newDataTable = JSON.parse(JSON.stringify(event.table))
        const buttonId = eventItem.buttonUpdateId

        // 设置主表
        let primaryKey = newDataTable[0].primaryKey
        const { value } = ButtonUpdate.getPrimaryKey({
            refs, buttonId,
            keyValue: newDataTable[0].primaryKeyValue,
            keyType: newDataTable[0].primaryKeyType,
        })
        let mainTable = {
            flag: 'delete',
            "primaryKey": primaryKey,
            [primaryKey]: value,

            table: newDataTable[0].tableName,
        }

        // 设置子表
        let childList = newDataTable.splice(1)
        let childTable = []
        for (let i = 0; i < childList.length; i++) {
            const childItem = childList[i];
            if (!childItem?.filterSqlTableValue) {
                return {}
            }
            let ninegrid = refs[childItem?.filterSqlTableValue]
            let ninegrid_tableData = ninegrid.tableData
            let table = ninegrid_tableData.map(item => {
                let obj = {
                    flag: mainTable.flag,
                    "primaryKey": primaryKey,
                    [childItem.tableFieldOutName]: value,
                    [childItem.primaryKey]: item[childItem.primaryKey],
                    table: childItem.tableName,
                    ftable: [],
                }
                return obj
            })
            childTable.push(...table)
        }




        let params = [mainTable, ...childTable]

        console.log('删除拼装数据：', params)
        // return
        const result = await execSqlData({
            datasourceId: event.table[0].dataSrouceId,
            param: params
        })


        if (result.code === 200 && result.success) {
            return result
        } else {
            return false
        }

    }
    // static async deleteConfig({ eventItem, event, results, refs }) {
    //     console.log('ButtonDelete deleteConfig', eventItem, event, results, refs)
    //     let newDataTable = JSON.parse(JSON.stringify(event.table))
    //     let buttonId = eventItem.buttonUpdateId

    //     console.log(newDataTable[0], event)
    //     let primaryKey = newDataTable[0].primaryKey
    //     const { value } = ButtonUpdate.getPrimaryKey({
    //         refs, buttonId,
    //         keyValue: newDataTable[0].primaryKeyValue,
    //         keyType: newDataTable[0].primaryKeyType,
    //     })
    //     let param = {
    //         // flag: 'delete',
    //         "primaryKey": primaryKey,
    //         [primaryKey]: value,
    //         table: newDataTable[0].tableName,
    //         ftable: []
    //     }

    //     const result = await execSqlDeleteData({
    //         datasourceId: newDataTable[0].dataSrouceId,
    //         param
    //     })
    //     if (result.code === 200 && result.success) {
    //         // this.setBusinessId(primaryKey)
    //         return result
    //     } else {
    //         return false
    //     }

    // }
    static messageConfig({ event, results }) {
        console.log('buttonDelete messageConfig')
        ButtonUpdate.messageConfig({ event, results })
    }
    static jumpConfig({ event, refs, exeEvent, eventItem }, { router }) {
        console.log('buttonDelete jumpConfig')
        ButtonUpdate.jumpConfig({ event, refs, exeEvent, eventItem }, { router })
    }

}

/**
 * @title 静态回填
 */
export class ButtonUpdateStatic {
    // 回填
    static executionCode({ eventItem, refMap, exeEvent }, { router }) {
        console.log('executionCode backFillConfig', eventItem, refMap, exeEvent)
        let event = eventItem.eventFunction.backFillConfig
        console.log(event, 'eventeventevent')
        if (!event.paramData.length) {
            return
        }
        let obj = {}

        obj = ButtonUpdate.assemblyData(event.paramData, refMap)

        let ninegrid = ButtonUpdate.getNinegrid(refMap, eventItem.buttonUpdateId)

        if (!ninegrid) {
            return MessagePlugin.error({ content: '未找到九宫格!' })
        }
        // 行索引
        let gridNumber = ninegrid.obj.gridNumber
        // 调用九宫格回填方法
        if (gridNumber) {
            refMap[ninegrid.obj.fatherGridId].editDataStatus(obj, gridNumber)
        } else {
            if (event.fatherGridId) {
                refMap[event.fatherGridId].addDataStatus(obj)
            } else {
                MessagePlugin.error({ content: '请配置回填九宫格!' })
            }
        }

        if (ninegrid) {
            ninegrid.hidePop && ninegrid.hidePop()
        }

    }
}


/**
 * @title 静态删除
 */
export class ButtonDeleteStatic {
    static async executionCode({ eventItem, refMap, exeEvent }, { router }) {
        const store = useButtonUpdateStore()
        const event = eventItem.eventFunction
        const list = store.staticDelList

        let results = []
        let shouldContinue = true;
        for (const key of list) {
            if (typeof this[key.event] === 'function' && shouldContinue) {
                try {
                    const result = await this[key.event]({
                        eventItem,
                        event: event[key.event],
                        results: results,
                        refs: refMap,
                        exeEvent
                    }, { router });
                    results.push(result)
                    if (result === false) { // 根据你的实际逻辑判断是否应该停止
                        shouldContinue = false;
                        break;
                    }
                } catch (error) {
                    shouldContinue = false;
                    console.error(error);
                    break;
                }
            }
        }

    }
    // 消息
    static messageConfig({ event, eventItem, refs, results }) {
        console.log('messageConfig', event, results, eventItem)

        // const res = results.saveConfigResults ? results.saveConfigResults : results.verifyConfigResults
        // console.log(res, event, 'xiaoxjiadjiasdajisdiasi')
        if (!event.isMessage) {
            return
        }
        let ninegrid = ButtonUpdate.getNinegrid(refs, eventItem.buttonUpdateId)

        if (!ninegrid) {
            return MessagePlugin.error({ content: '未找到九宫格!' })
        }
        // 行索引
        let gridNumber = ninegrid.obj.gridNumber
        console.log(ninegrid, 'gridNumber')
        ninegrid.deleteDataStatus(gridNumber)

        if (event.messageType === 'tip') {
            MessagePlugin.success({ content: event.successMessage })
        } else {
            this.messagePopup({ body: event.successMessage, theme: 'success' })
        }



        // if (res && res.success) {
        //     let msg = event.successMessage.length ? event.successMessage : res.msg
        //     if (event.messageType === 'tip') {
        //         MessagePlugin.success({ content: msg })
        //     } else {
        //         this.messagePopup({ body: msg, theme: 'success' })
        //     }

        // } else {
        //     let msg = event.errorMessage.length ? event.errorMessage : res.msg
        //     if (event.messageType === 'tip') {
        //         MessagePlugin.error({ content: msg })
        //     } else {
        //         this.messagePopup({ body: msg, theme: 'danger' })

        //     }
        // }
    }
}

/**
 * @title 网络请求
 */
export class ButtonNetworkRequest {
    static buttons = ['cpt-button', 'cpt-switch', 'cpt-drawarea', 'cpt-radio', 'cpt-number']

    static verifyEventConfig(item) {
        try {
            return this.buttons.some(type => item.cptKey?.includes(type))
        } catch (error) {
            return false
        }
    }
    // 打开弹窗
    static openConfig(refMap, currentCpt) {
        refMap['networkRequestConfig'].opened(currentCpt, refMap)
    }
    // 执行代码
    static async executionCode({ eventItem, refMap, exeEvent }, { router }, callFn = null) {

        const store = useButtonUpdateStore()
        const event = eventItem.eventFunction
        const list = store.networkRequest

        let results = {}
        let shouldContinue = true;
        for (const key of list) {
            if (typeof this[key.event] === 'function' && shouldContinue) {
                try {
                    const result = await this[key.event]({
                        eventItem,
                        event: event[key.event],
                        results: results,
                        refs: refMap,
                        exeEvent
                    }, { router });
                    results[`${key.event}Results`] = result
                    if (result === false) { // 根据你的实际逻辑判断是否应该停止
                        shouldContinue = false;
                        break;
                    }
                } catch (error) {
                    shouldContinue = false;
                    console.error(error);
                    break;
                }
            }
        }
        if (callFn) { callFn() }

    }
    static verifyConfig() {
        console.log('networkRequest verifyConfig', arguments)

        return ButtonUpdate.verifyConfig(...arguments)
    }
    static messageConfig({ event, results }) {
        console.log('networkRequest messageConfig')
        return ButtonUpdate.messageConfig({ event, results })
    }
    static backFillDataConfig({ event, results, refs }) {
        console.log('networkRequest backFillDataConfig', event, results)

        const dataJson = JSON.parse(JSON.stringify(event))
        const result = ButtonUpdate.backDataHandler(results.verifyConfigResults?.data)

        console.log(dataJson, result)

        dataJson.paramData.forEach(item => {
            console.log(item)
            let targetDiv = refs[item.target]
            if (targetDiv) {
                targetDiv.setValue(result[0][item.to])
            }
        })
    }
    static jumpConfig() {
        console.log('networkRequest jumpConfig')
        return ButtonUpdate.jumpConfig(...arguments)
    }

}

export class SelectComponent {
    // 'cpt-choose-place'
    static checks = ['cpt-drawarea', 'cpt-text', 'cpt-input', 'cpt-input-mobile', 'cpt-total', 'cpt-switch', 'cpt-phone-number', 'cpt-number',
        'cpt-amount', 'cpt-checkbox', 'cpt-date-picker', 'cpt-calendar', 'cpt-select-mobile', 'cpt-date-picker-mobile', 'cpt-select', 'cpt-image', 'cpt-choose-place',
        'cpt-ninegrid'
    ]
    static buttonType = ['update', 'delete']
    // 显示勾选器
    static modelShowHide(item) {
        const store = useButtonUpdateStore()
        let isSelectShow = store.selectComponent.isSelect
        let isCurrentComp = item?.cptType !== 'button-update' || item?.cptType !== 'button-delete'
        let isMoreSelectShow = store.selectMoreComponent.isSelect
        let isCheckComps = this.checks.some(x => item.cptKey?.includes(x))

        let flag = (isSelectShow || isMoreSelectShow) && isCurrentComp && isCheckComps
        return flag
    }
    static modelShowForceRefresh(item, currentCpt) {
        const store = useButtonUpdateStore()
        let isSelect = store.multSelectComponent.isSelect
        // 是页签时
        if (currentCpt?.cptKey === 'cpt-tab') {
            // 在页签里面才显示
            isSelect = store.multSelectComponent.isSelect && item.cptOption.attribute.cptFatherId
        }
        return isSelect
    }
    // 缓存显示勾选器逻辑
    static checksForCache = ['cpt-text', 'cpt-input', 'cpt-textarea', 'cpt-input-mobile', 'cpt-total', 'cpt-switch', 'cpt-phone-number', 'cpt-number',
        'cpt-amount', 'cpt-date-picker', 'cpt-calendar', 'cpt-select-mobile', 'cpt-date-picker-mobile', 'cpt-select', 'cpt-image', 'cpt-input-search', 'cpt-richtxt',
        'cpt-ninegrid', 'cpt-table', 'cpt-scroll-list', 'cpt-scroll-table',
    ]
    static modelShowHideForCache(item, currentCpt) {
        const store = useButtonUpdateStore()
        let isSelectShow = store.selectComponent.isSelect
        let isCurrentComp = item?.cptType !== 'button-update' || item?.cptType !== 'button-delete'
        let isMoreSelectShow = store.selectMoreComponent.isSelect
        let isMultSelectShow = false
        // 是页签时
        if (currentCpt?.cptKey === 'cpt-tab') {
            // 在页签里面才显示
            isMultSelectShow = store.multSelectComponent.isSelect && item.cptOption.attribute.cptFatherId
        } else {
            // 不是页签时，激活 multSelectComponent 就显示
            isMultSelectShow = store.multSelectComponent.isSelect
        }


        let isCheckComps = this.checksForCache.some(x => item.cptKey?.includes(x))
        let flag = (isSelectShow || isMoreSelectShow || isMultSelectShow) && isCurrentComp && isCheckComps
        return flag
    }
    // 二级菜单显示
    static secondaryMenu(item) {
        const store = useButtonUpdateStore()
        const isCurrent = item?.cptType === 'button-update' || item?.cptType === 'button-delete'
        const IsMoreSelect = store.selectMoreComponent.isSelect
        // const isSelect = store.selectComponent.isSelect
        return IsMoreSelect && isCurrent
    }
    // 取消弹窗
    static showCancel(item) {
        const store = useButtonUpdateStore()
        return store.selectComponent.isSelect
    }

    // 勾选完成执行
    static secondaryMenuSuccess() {
        const store = useButtonUpdateStore()
        this.secondaryMenuCancel()
        store.setMoreSelectComponentStatus('update')
    }
    // 取消
    static secondaryMenuCancel() {
        const store = useButtonUpdateStore()
        console.log(store, 'store')
        store.setIsSelectComponent(false)
        store.setIsMoreSelectComponent(false)
        store.setSelectComponentStatus('set')
        store.setDialogShow(true)
    }

    // 勾选
    static checkedSelectComponent(item, { sourceId } = {}) {
        const store = useButtonUpdateStore()
        if (store.selectComponent.isSelect) {
            return store.selectComponent.id == item.id
        } else if (store.selectMoreComponent.isSelect) {
            let flag = store.selectMoreComponent.target.some(x => x.id === item.id)
            return flag
        } else if (store.multSelectComponent.isSelect) {
            return !!store.multSelectComponent.tempTarget[sourceId]?.[item.id]
        }
    }
    // 选择控件
    static changeSelectComponent(item, { checked, sourceId, index } = {}) {
        // debugger
        const store = useButtonUpdateStore()
        if (store.selectComponent.isSelect) {
            store.setSelectComponentControl({ id: item.id, title: item.cptTitle })
            store.setIsSelectComponent(false)
            store.setDialogShow(true)
            store.setSelectComponentStatus('update')
        } else if (store.selectMoreComponent.isSelect) {
            let componentIndex = store.selectMoreComponent.target.findIndex(x => x.id === item.id)
            if (componentIndex === -1) {
                store.setMoreSelectComponentAdd({ id: item.id, title: item.cptTitle })
            } else {
                store.setMoreSelectComponentRemove(componentIndex)
            }
        } else if (store.multSelectComponent.isSelect) {
            // console.log('checked--',checked);
            const tempTarget = store.multSelectComponent.tempTarget
            if (checked) {
                if (!tempTarget[sourceId]) {
                    tempTarget[sourceId] = {}
                }
                tempTarget[sourceId][item.id] = { id: item.id, title: item.cptTitle, index, cptKey: item.cptKey }
            } else {
                delete tempTarget[sourceId][item.id]
            }
            // console.log('multSelectComp-tempTarget-',tempTarget);
        }
    }

}

/**
 * @title 执行大屏事件
 */
export class ExecuteDPEvent {
    static eventScroll = null
    static initLoad({ designCache, execute }) {
        console.log('执行大屏处理事件..')
        setTimeout(() => {

            try {
                const eventData = designCache.eventData?.loadData
                console.log(eventData)
                if (!eventData || eventData.length == 0) {
                    return
                }
                eventData.forEach(item => {
                    // 判断当前事件下的组件
                    let eventComp = designCache.components.find(c => c.id === item.eventData.eventCompId)
                    if (eventComp) {
                        // 判断当前组件下事件是否比配
                        let hasEvent = eventComp.cptOption.interaction.eventList.find(e => e?.ID === item.eventData.ID)
                        if (hasEvent) {
                            // 执行
                            execute(eventComp.cptOption.interaction, 'default', '', eventComp.cptKey)
                        }
                    }
                })
    
            } catch (error) {
                console.error('执行大屏处理事件失败:', error)
            }
            console.log('结束大屏处理事件..')
        },300)
    }

    static initScroll({ designCache, execute }) {
        let previewPageEl = document.querySelector('.preview-page')
        this.eventScroll = (e) => {
            console.log('执行滚动事件')
            try {
                const eventData = designCache.eventData?.scrollData
                if (!eventData || eventData.length == 0) {
                    return
                }
                eventData.forEach(item => {
                    // 判断当前事件下的组件
                    let eventComp = designCache.components.find(c => c.id === item.eventData.eventCompId)
                    if (eventComp) {
                        // 判断当前组件下事件是否比配
                        let hasEvent = eventComp.cptOption.interaction.eventList.find(e => e?.ID === item.eventData.ID)
                        if (hasEvent) {
                            // console.log(eventComp,item,'doikaokdoasdosdko')
                            let scrollTop = Math.ceil(e.target.scrollTop)
                            console.log(item.eventScrollIf, scrollTop, item.eventScrollY, 'asodkoakdoasdkosa')
                            if (item.eventScrollIf == 0 && scrollTop > item.eventScrollY) {
                                execute(eventComp.cptOption.interaction, 'default', '', eventComp.cptKey)
                                return
                            } else if (item.eventScrollIf == 1 && scrollTop < item.eventScrollY) {
                                execute(eventComp.cptOption.interaction, 'default', '', eventComp.cptKey)
                                return
                            } else if (item.eventScrollIf == 2 && scrollTop == item.eventScrollY) {
                                execute(eventComp.cptOption.interaction, 'default', '', eventComp.cptKey)
                                return
                            }
                            // 执行
                        }
                    }
                })

            } catch (error) {
                console.error('执行大屏处理事件失败:', error)
            }
        }
        if (previewPageEl) {
            previewPageEl.addEventListener('scroll', this.eventScroll);
        }
    }
    // static eventScroll() {
    //     console.log('执行滚动事件')
    //     // this.execute('scrollData',...arguments)
    // }
    static clearScroll() {
        console.log('清除滚动事件')
        let previewPageEl = document.querySelector('.preview-page')
        if (!previewPageEl) {
            return
        }
        previewPageEl.removeEventListener('scroll', this.eventScroll)
    }
}


/**
 * @title 直播
 */
export class LivePlayer {
    static onConfirmEvent(liveStore, currentCpt, cacheComponents) {
        let liveInfo = {
            targetId: liveStore.selectEventInfo.targetId,
            liveId: currentCpt.id,
            eventMethod: liveStore.selectEventInfo.eventInfo.event
        }
        let selectComp = cacheComponents.find(item => item.id === liveStore.selectEventInfo.targetId)

        if (!selectComp) {
            console.error('直播关联控件异常');
            return
        }
        let eventIndex = selectComp.cptOption.interaction.eventList.findIndex(x => x.eventMethod === liveStore.selectEventItem.event)
        if (!liveStore.selectEventInfo.checked) {
            selectComp.cptOption.interaction.eventList.splice(eventIndex, 1)
        } else {
            let event = {
                intType: "livePlayerEvent", //交互类型
                intName: "直播事件操作",
                title: currentCpt.cptTitle,
                multi: false,
                ID: +new Date(),
                ...liveInfo
            }
            if (eventIndex === -1) {
                selectComp.cptOption.interaction.eventList.push(event)
            } else {
                selectComp.cptOption.interaction.eventList[eventIndex] = event
            }
        }
    }
    static checked(item, liveStore) {
        return liveStore.selectEventInfo.targetId == item.id && liveStore.selectEventInfo.checked
    }
    // 选中直播操作组件
    static changeSelected(checked, item, liveStore) {
        let id = liveStore.selectEventInfo.targetId ? null : item.id
        liveStore.setSelectComponent({ id, checked })
    }
    // 蒙版
    static showModelBoxAll(show, item) {
        return show && item.cptKey != 'cpt-live'
    }
}


/**
 * @title 脚本
 */
export class Tools {
    // 数组去重
    static removeDuplicates(arrayOfObjects, keyProp) {
        return arrayOfObjects.reduce((acc, item) => {
            const existingItem = acc.find(existing => existing[keyProp] === item[keyProp]);
            if (!existingItem) {
                acc.push(item);
            }
            return acc;
        }, []);
    }
    // 通过datasetId查询字段列表
    static getFieldArray(datasetId) {
        return new Promise((resolve, reject) => {
            // cptDataForm.datasetId
            getDetailApi(datasetId)
                .then((res) => {
                    let iptstr = res.data.sqlText;
                    if (!iptstr) {
                        // this.$message.Message.error("SQL不能为空");
                        return []
                    }
                    // 返回 executeSelectKey 的 Promise 并直接在其 then 中处理结果
                    return executeSelectKey({
                        sql: iptstr,
                        datasourceId: res.data.datasourceId,
                        isArray: true,
                    });
                })
                .then((result) => {
                    console.log(result, "result");

                    // 直接根据 result 数据结构来决定是否赋值以及如何赋值
                    if (result && result.data) {
                        resolve(result.data)
                    } else {
                        resolve([])
                    }
                })
                .catch((error) => {
                    // this.$message.error("执行查询时发生错误:", error);
                    // this.$message.error("查询数据失败，请稍后重试");
                    // 当出现错误时，清空或设置为空数组
                    reject([])
                });
        })
    }

    /**
    * 在多级嵌套数组中递归查找指定cptKey的项
    * @param {Array} array - 多级嵌套的数组对象
    * @param {String} cptKeyToFind - 需要查找的cptKey值
    * @returns {Array} result - 所有匹配到的项组成的数组
    */
    static findCptKeyInNestArray(array, cptKeyToFind) {
        let result = [] // 准备存放所有匹配结果的数组

        // 递归搜索数组中的每一项及其子项
        const searchInChildren = items => {
            items.forEach(item => {
                // 如果当前项的cptKey与目标key匹配，则加入结果数组
                if (item.cptKey === cptKeyToFind) {
                    result.push(item)
                }

                // 如果当前项包含子项（即数组），且子项数量大于0，则对子项进行递归搜索
                if (Array.isArray(item.children) && item.children.length > 0) {
                    searchInChildren(item.children);
                }
            })
        }
        // 对传入的数组开始递归搜索
        searchInChildren(array);

        return result; // 返回所有匹配结果
    }
    /**
     * 创建一个函数，接收location.search并将其转换为对象
     * @returns {}
     */
    static getQueryParamsAsObject() {
        const search = window.location.search;
        console.log('getQueryParamsAsObject search', search)
        const searchParams = new URLSearchParams(search);
        console.log('getQueryParamsAsObject searchParams', searchParams)
        // 使用Object.fromEntries将URLSearchParams对象转换为普通对象
        const queryParams = Object.fromEntries(searchParams.entries());
        console.log('getQueryParamsAsObject queryParams', queryParams)

        return queryParams;
    }

    /**
     * @title 过滤当前大屏数据集
     */
    // 过滤数据 (当前大屏数据集)
    static async filterSqlTableData({ component }) {
        // 提取非空 datasetId 并放入数组中
        let datasetIds = component
            .map(item => {
                const datasetId = item.cptOption.cptDataForm?.datasetId
                // 判断是否是多个id 
                return datasetId?.includes(',') ? null : (datasetId ? { id: datasetId, componentId: item.id } : null)
            })
            .filter(x => x);
        // 将数组转为 Set 以确保唯一性（如果 filterSqlTableDetail 需要唯一值）
        // datasetIds = Array.from(new Set(datasetIds))
        console.log(datasetIds, 'datasetIdsdatasetIdsdatasetIds')
        datasetIds = this.removeDuplicates(datasetIds, 'id')
        console.log(datasetIds, 'datasetIdsdatasetIdsdatasetIds111')

        // 等待 filterSqlTableDetail 完成并更新数据和页面配置

        let result = await this.filterSqlTableDetail(datasetIds)

        return result
    }
    // 过滤当前大屏数据集
    static async filterSqlTableDetail(datasetIds) {
        const allPromise = datasetIds.map(async ({ id, componentId }) => {
            try {
                const resItem = await getDetailApi(id);
                return { ...resItem.data, componentId };
            } catch (err) {
                console.error('合计组件数据集查询失败:', err);
            }
        });

        // 等待所有的请求完成并收集结果
        const resultArray = await Promise.all(allPromise);
        return resultArray;
    }
    /**
     * @title 获取地址栏参数
     * @return {}
     */
    static getUrlParams() {
        // 获取地址栏参数字符串（不含问号）
        const queryString = window.location.search.slice(1);

        // 将地址栏参数字符串解析为对象
        const params = {};
        queryString.split('&').forEach(param => {
            const [key, value] = param.split('=');
            if (key && value) {
                params[decodeURIComponent(key)] = decodeURIComponent(value.replace(/\+/g, ' '));
            }
        });

        console.log(`获取地址栏参数：${params}`); // 输出转换后的参数对象
        return params
    }




}

export class WeChat {
    /**
     * @title 判断当前是否是微信环境
     */
    static verifyWx() {
        const ua = window.navigator.userAgent.toLowerCase();
        return /micromessenger/.test(ua); // 包含微信关键词
    }
    /**
     * @title 返回
     * @param {*} options 
     * @param {*} options.delta 返回几级页面 
     * @param {*} options.data 返回参数 
     */
    static goBack(options) {
        let timer = setTimeout(() => {
            const { $wxsdk } = window.app.config.globalProperties
            $wxsdk.miniProgram.postMessage({
                type: "BACKPARAMS",
                data: options?.data
            })
            $wxsdk.miniProgram.navigateBack({
                delta: options?.delta
            })
            clearTimeout(timer)
        }, 1000)
    }
    /**
     * @title 拨打电话
     * @param {*} options 
     * @param {*} options.phoneNumber 手机号码 
     */
    static MakePhoneCall(options) {
        let timer = setTimeout(() => {
            const { $wxsdk } = window.app.config.globalProperties
            $wxsdk.miniProgram.navigateTo({
                url: '/pages/tele/tele?phoneNumber=' + options.phoneNumber,//跳转回小程序页面,并传参
                success: function () {
                    console.log('成功跳回小程序')
                },
                fail: function () {
                    console.log('跳转回小程序页面失败');
                },
            });
            // $wxsdk.miniProgram.postMessage({
            //     type: "MakePhoneCall",
            //     data: options?.phoneNumber
            // })
            clearTimeout(timer)
        }, 500)
    }
    /**
     * @title 打开导航
     * @param {*} options 
     * @param {*} options.scale 缩放比例  
     * @param {*} options.latitude 纬度 使用 gcj02 国测局坐标系
     * @param {*} options.longitude 经度 使用 gcj02 国测局坐标系 
     */
    static OpenLocation(options) {
        let timer = setTimeout(() => {
            const { $wxsdk } = window.app.config.globalProperties
            $wxsdk.miniProgram.navigateTo({
                url: '/pages/navi/navi?longitude=' + options.longitude + '&latitude=' + options.latitude + '&scale=' + options.scale,//跳转回小程序页面,并传参
                success: function () {
                    console.log('成功跳回小程序')
                },
                fail: function () {
                    console.log('跳转回小程序页面失败');
                },
            });

            // $wxsdk.miniProgram.postMessage({
            //     type: "OpenLocation",
            //     data: options
            // })
            clearTimeout(timer)
        }, 500)
    }




}



/**
 * @title 获取日期
 */
export class GetDate {
    static get(format) {
        const date = new Date()
        const year = date.getFullYear()
        let month = String(date.getMonth() + 1)
        let day = String(date.getDate())
        let hours = String(date.getHours())
        let minutes = String(date.getMinutes())
        let seconds = String(date.getSeconds())

        month = month < 10 ? `0${month}` : month
        day = day < 10 ? `0${day}` : day
        hours = hours < 10 ? `0${hours}` : hours
        minutes = minutes < 10 ? `0${minutes}` : minutes
        seconds = seconds < 10 ? `0${seconds}` : seconds

        switch (format) {
            case 'yyyy-MM-dd':
                return `${year}-${month}-${day}`
            case 'yyyyMMddhhmmss':
                return year + month + day + hours + minutes + seconds
            case 'yyyyMMdd':
                return year + month + day
            default:
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
        }
    }
    // 校验是否是日期
    static isValidDate(dateStr) {
        var d = new Date(dateStr);
        return !isNaN(d.getTime());
    }
}


/**
 * @title 图层
 * @desc 图层排序按照: 复杂组件(九宫格->选项卡->组) -> 单组件
 */
export class ComponentTreeBar {
    static init({ cacheComponents }) {
        const store = useComponentTreeStore()
        const list = this.filterList(cacheComponents)
        console.log(list, 'tabList');
        store.setList(list)
    }
    static filterList(components) {
        let tabList = []
        let tabTree = []
        let ninegridList = []
        let ninegridTree = []
        let groupList = []
        let groupTree = []
        let itemTree = []
        for (let i = 0; i < components.length; i++) {
            let item = components[i]
            // 判断选项卡
            const isTab = item?.cptType === 'combination'
            const isFirstTab = item.cptOption.attribute.cptTabLevel === 1
            const isFather = item.cptOption.attribute.cptFatherId
            if (isTab && isFirstTab && !isFather) {
                tabList.push(item)
            }
            // 九宫格
            const isNinegrid = item?.cptType === "ngcombination"

            if (isNinegrid && !isFather) {
                ninegridList.push(item)
            }

            // 组
            if (this.verifyGroupItem(item)) {
                groupList.push(item)
            }

            if (this.verifyItem(item, components)) {
                itemTree.push(this.setItemObj(item, { title: item.cptTitle, id: item.id }))
            }


        }
        // 选项卡
        console.log(tabList, 'tabList');
        for (let i = 0; i < tabList.length; i++) {
            let item = tabList[i]
            console.log(item);
            tabTree.push(this.forTabTree(item, i, components))
        }

        // 九宫格
        for (let i = 0; i < ninegridList.length; i++) {
            let item = ninegridList[i];
            ninegridTree.push(this.forNinegridTree(item, i, components))
        }

        groupTree = this.forGroupTree(groupList, components)

        console.log('九宫格:', ninegridTree);

        return [...tabTree, ...ninegridTree, ...groupTree, ...itemTree]
    }

    static forTabTree(item, fatherIndex, components) {

        let result = this.setItemObj(item, { id: item.id, title: item.cptTitle, children: [] })


        for (const key in item.tabGroup) {
            let keyComps = []
            let groupList = []
            // 获取tabGroup控件对象
            for (let i = 0; i < components.length; i++) {
                let cItem = components[i]
                const comp = item.tabGroup[key]?.includes(cItem.id)

                if (comp) keyComps.push(cItem)
            }

            let dataText = JSON.parse(item.cptOption.cptDataForm.dataText)
            let childrenGroup = {}
            if (dataText.options.length) {
                let index = dataText.options.findIndex(optItem => optItem.value === key)
                if (index !== -1) {
                    const { label, value } = dataText.options[index]
                    childrenGroup = this.setItemObj({}, { id: null, title: label, value, children: [] })
                }
            }


            for (let i = 0; i < keyComps.length; i++) {
                const keyItem = keyComps[i];

                const level = `${fatherIndex}-${i}`
                if (keyItem.id == item.id) {
                    continue
                }

                if (keyItem.cptType === 'combination') {
                    childrenGroup.children.push(this.forTabTree(keyItem, level, components))

                } else if (keyItem.cptType === 'ngcombination') {
                    childrenGroup.children.push(this.forNinegridTree(keyItem, level, components))

                } else if (this.verifyGroupItem(keyItem, true)) {
                    groupList.push(keyItem)
                } else {
                    // 过滤父级选项卡边框
                    if (keyItem?.cptType !== 'combination-border' && keyItem?.cptType !== 'ngcombination-border') {
                        childrenGroup.children.push(
                            this.setItemObj(keyItem, { id: keyItem.id, title: keyItem.cptTitle })
                        )
                    }


                    // let tabBorder = father && father.group.includes(keyItem.id) && keyItem?.cptType === 'combination-border'
                    // console.log(father, keyItem, 'tabBordertabBordertabBorder');
                    // if (!tabBorder) {
                    //     childrenGroup.children.push(
                    //         this.setItemObj(keyItem, { id: keyItem.id, title: keyItem.cptTitle })
                    //     )
                    // }


                    // let isCurrentTabBorder = (item?.group.includes(keyItem.id) && keyItem?.cptType === 'combination-border')
                    // if (!isCurrentTabBorder) {
                    //     childrenGroup.children.push(
                    //         this.setItemObj(keyItem, { id: keyItem.id, title: keyItem.cptTitle })
                    //     )
                    // }

                }
            }
            if (groupList.length) {
                childrenGroup.children.push(...this.forGroupTree(groupList, components))
            }

            result.children.push(childrenGroup)


        }

        // 查询选项卡边框
        // let tabBorder = components.find(findItem => item.group.includes(findItem.id) && findItem?.cptType === 'combination-border')

        // result.children.push(
        //     this.setItemObj(tabBorder, { id: tabBorder.id, title: tabBorder.cptTitle })
        // )
        let tabGroupComp = components.filter(findItem => item.group?.includes(findItem.id) && findItem?.cptType !== 'combination')
        for (const tabGroupCompItem of tabGroupComp) {
            result.children.push(
                this.setItemObj(tabGroupCompItem, { id: tabGroupCompItem.id, title: tabGroupCompItem.cptTitle })
            )
        }


        return result
    }
    static forNinegridTree(item, fatherIndex, components) {
        if (item?.cptType === 'ngcombination') {
            let children = []
            for (const key in item.tabGroup) {
                if (key == 'index-0') {
                    let keyComps = []
                    // 获取tabGroup控件对象
                    for (let i = 0; i < components.length; i++) {
                        let cItem = components[i]
                        const comp = item.tabGroup[key]?.includes(cItem.id)

                        if (comp) keyComps.push(cItem)
                    }

                    // 添加子组件
                    for (let i = 0; i < keyComps.length; i++) {
                        const keyItem = keyComps[i];
                        const { cptFatherId } = keyItem.cptOption.attribute
                        const level = `${fatherIndex}-${i}`
                        if (keyItem.cptType === 'combination') {
                            children.push(this.forTabTree(keyItem, level, components, item))
                        } else if (keyItem.cptType === 'ngcombination') {
                            children.push(this.forNinegridTree(keyItem, level, components))
                        } else {
                            if (cptFatherId == item.id && keyItem?.cptType !== 'combination-border' && keyItem?.cptType !== 'ngcombination-border') {
                                children.push(
                                    this.setItemObj(keyItem, { id: keyItem.id, title: keyItem.cptTitle })
                                )
                            }

                        }
                    }
                }



            }

            let tabGroupComp = components.filter(findItem => item.group?.includes(findItem.id) && findItem?.cptType !== 'ngcombination')
            for (const tabGroupCompItem of tabGroupComp) {
                children.push(
                    this.setItemObj(tabGroupCompItem, { id: tabGroupCompItem.id, title: tabGroupCompItem.cptTitle })
                )
            }

            return this.setItemObj(item, { id: item.id, title: item.cptTitle, children })
        }
    }
    static forGroupTree(list, components) {
        // 创建一个空对象来存储分组后的数据
        let groupedList = [];
        let addedValues = new Set();

        for (let i = 0; i < list.length; i++) {
            const item = list[i];
            let itemObj = this.setItemObj({}, { id: null, title: '组', value: item.groupCompName, children: [] })


            // 去重逻辑：仅当value未被添加过时才加入groupedList
            if (!addedValues.has(itemObj.value)) {
                addedValues.add(itemObj.value);
                for (let j = 0; j < item.group.length; j++) {
                    const groupItemId = item.group[j];
                    let groupItemComp = components.find(x => x.id == groupItemId && x.groupCompName == item.groupCompName);
                    if(groupItemComp) {
                        itemObj.children.push(
                            this.setItemObj(groupItemComp, { id: groupItemComp?.id, title: groupItemComp?.cptTitle })
                        );
                    }
                }
                groupedList.push(itemObj);
            }
        }

        return groupedList
    }

    static verifyGroupItem(item, hasFahter) {
        const isTab = item?.cptType !== 'combination' && item?.cptType !== 'combination-border'
        const isNinegrid = item?.cptType !== 'ngcombination' && item?.cptType !== 'ngcombination-border'
        const isGroup = item?.group && item?.group.length
        const isFather = hasFahter ? false : item.cptOption.attribute?.cptFatherId
        if ((isTab && isNinegrid) && isGroup && !isFather) {
            return item
        } else {
            return false
        }
    }
    static verifyItem(item, components) {
        // 是否是九宫格
        const isTab = item?.cptType !== 'combination' && item?.cptType !== 'combination-border'
        // 是否是选项卡组合组件
        const isTabGroup = components.some(c => c?.cptType === 'combination' && c.group?.includes(item.id))
        // 是否是九宫格
        const isNinegrid = item?.cptType !== 'ngcombination' && item?.cptType !== 'ngcombination-border'
        // 是否是组合组件
        const isGroup = !item?.group || (item?.group && item?.group.length == 0)
        // 是否有父级
        const isFather = item.cptOption.attribute?.cptFatherId
        // console.log(isTabGroup, item, item.cptTitle, 'isTabGroup');
        if ((isTab && isNinegrid) && isGroup && !isFather && !isTabGroup) {
            return item
        } else {
            return false
        }
    }
    static setItemObj(item, { title, id, children, value }) {
        let data = {
            title,
            id,
            data: item,
            icon: this.setIcon(item, children)
        }
        if (children) {
            data['children'] = children
            data['isOpen'] = true
        }
        if (value) {
            data['value'] = value
        }
        return data
    }
    static setIcon(item, isChilren) {
        let datasetIcons = ['json', 'json', 'api', 'sql', 'set', 'socket', 'json']
        let dataSource = item?.cptOption?.cptDataForm?.dataSource
        let icon = dataSource ? datasetIcons[dataSource] + '.png' : false
        // console.log(icon, item, 'icon');
        if (!icon) {
            if (isChilren) {
                icon = `group.svg`
            } else {
                icon = `component.svg`
            }
        }
        return icon ? `url(${require(`@/assets/icon/dataset/${icon}`)})` : ''
    }



    /**
     * @title 九宫格数据处理
     */
    static ninegridHandler() {

    }
}

/**
 * @title 悬浮框
 */
export class Suspension {
    static moveGroupComponent({ fatherBox, selectedList, index, onGroup, callback }) {
        if (!fatherBox) {
            return
        }
        if (selectedList.length - 1 === index) {
            let fatherIndex = String(fatherBox.cptOption.attribute.cptIndex).slice(0, 1)
            let selectedObj = {}

            selectedObj[fatherBox.id] = fatherBox

            for (let i = 0; i < selectedList.length; i++) {
                const iterator = selectedList[i];
                // let groupItem = cacheComponents.find(x => x.id === iterator.id)
                // if (!groupItem) {
                //     continue
                // }
                // groupItem.cptOption.attribute.cptIndex = Number(String(fatherIndex + '00000' + (i + 1)))
                callback && callback(iterator)
                selectedObj[iterator.id] = iterator
            }
            setObj(cacheChoices, reactive(selectedObj))
            onGroup.init()
            console.log(selectedObj, cacheComponents, 'qdwoi0jkqwd0iwqdioqdko');
        }
    }
    static isGroupCompSetIndex(item, cacheComponents) {
        let isTrue = cacheComponents.find(cItem => {
            return item.group?.includes(cItem.id) && cItem?.cptType === 'cpt-suspension'
        })
        return isTrue

    }
}
/**
 * @title 注册监听事件
 */
export class GetSqlParams {
    static getBracketStr(str) {
        let arr = []
        var reg = /\{(.*?)\}/gi;
        var tmp = str.match(reg);
        if (tmp) {
            for (var i = 0; i < tmp.length; i++) {
                // alert(tmp[i].replace(reg, "$1")); // 不保留中括号
                arr.push(tmp[i].replace(reg, "$1").split('.')[1])
            }
            return arr
        } else {
            console.log("no match.");
        }
    }
}

/**
 * @title 注册监听事件
 */
export class AddEventListener {
    static message(callback) {
        window.addEventListener('message', function (event) {
            if (event.data) {
                callback(event)
            }
        });
    }
}
/**
 * @title iframe控件外部通讯内部执行级联
 */
export class IframeInteraction {
    // 子级控件条件刷新
    static sonRefreshCptData({ event, cacheComponents, refMap, refreshComp, interval }) {
        console.log('123123123123123121233');
        let needRefreshCpt = []
        let data = event.data
        if (!data || !cacheComponents) {
            clearInterval(interval);
            return;
        }
        if (typeof data == 'string') data = JSON.parse(data)
        Object.keys(data).forEach(item => {
            cacheComponents.forEach(ele => {
                // 给iframe下子组件存储iframe级联的数据
                const cptTree = ele.cptKey === 'cpt-tree'
                const isDefault = ele.cptOption.attribute['isDefault']
                console.log(data, 'datadatadata');
                if (cptTree && isDefault && (data && data?.value)) {
                    needRefreshCpt.push(ele)
                }
                const datasetParams = ele?.cptOption?.cptDataForm?.datasetParams || [];
                datasetParams.forEach(it => {
                    if (it == item) needRefreshCpt.push(ele)
                })
            })
        });
        console.log(needRefreshCpt, 'needRefreshCptneedRefreshCpt')
        if (needRefreshCpt.length < 1) {
            clearInterval(interval);
            return;
        };
        let refreshCompTemp = []
        needRefreshCpt.forEach(item => {
            const cptDataForm = item?.cptOption?.cptDataForm;
            const refreshItem = {
                id: item.id,
                hasRefresh: true
            }
            if (refMap[item.id]) {
                refMap[item.id]?.refreshCptData?.(cptDataForm, data);
                refreshItem.hasRefresh = false;
            }
            refreshCompTemp.push(refreshItem);
        })
        refreshComp.value = refreshCompTemp
    }
}

/**
 * @title 
 */

export class CombinationPage {
    static init(initProps) {
        const { config, cpt, drop, onGroup, cacheComponents, cacheChoices } = initProps
        if (config.cptKey === 'cpt-combination-page') {
            console.log(componentOptions, 'componentOptionsasdasdasdas');

            let select = JSON.parse(JSON.stringify(finArrChildrenValue(componentOptions[1].children, 'cptKey', 'cpt-select')))

            select.option.attribute.conciseMode = true
            select.option.attribute.conciseMode_image = '/imgPool/202408/fdd4176f23234e3e849c3972ae4dda51.png'
            select.option.attribute.conciseMode_position = 'top'
            select.option.attribute.combinationCompId = cpt.id
            select.width = 40
            select.height = 35


            drop({
                type: 'HANLERDROP',
                handler: { ...select, cptX: cpt.cptX + 100, cptY: cpt.cptY, type: 'cpt-combination-page-select' }
            })

            let pageSelect = cacheComponents.find(item => item.cptOption.attribute.combinationCompId == cpt.id && item.cptType == 'cpt-combination-page-select')

            cpt.cptOption.attribute.combinationCompId = pageSelect.id


            console.log(cpt, pageSelect, cacheComponents, "?????");


            cacheChoices[cpt.id] = cpt
            cacheChoices[pageSelect.id] = pageSelect
            onGroup.init()




        }


        // this.createButton(config, cpt)
    }
    // 设置下拉框的值
    static setTabData(current, combinationComp, event, cacheComponents) {
        let select = current.cptKey == 'cpt-select' ? current : combinationComp.cptKey == 'cpt-select' ? combinationComp : false
        let tab = cacheComponents.find(item => item.id == event.tabId)
        select.cptOption.cptDataForm.dataText = tab.cptOption.cptDataForm.dataText

    }
    static setTabZIndex(current, combinationComp, event, cacheComponents) {
        // let combinationComp = cacheComponents.find(item => item.id == current.cptOption.attribute.combinationCompId)
        let tab = cacheComponents.find(item => item.id == event.tabId)
        let tabZIndex = tab.cptOption.attribute.cptIndex
        for (let i = 0; i < cacheComponents.length; i++) {
            const item = cacheComponents[i];
            if (item.id == combinationComp.id || item.id == current.id) {
                item.cptOption.attribute.cptIndex = tabZIndex

            }
        }
    }
    static onTabChange(value, current, refMap) {
        let event = current.cptOption.interaction.eventList.find(e => e.intType == 'combinationTabPage')
        if (!event) {
            return
        }
        if (!event.tabId) {
            return
        }
        // 下拉框切换
        if (current.cptKey == 'cpt-select') {
            let select = refMap[current.id]
            let index = select.newData.options.findIndex(item => item.value == value)
            refMap[event.tabId].changeTab(value, index)
        }
        if (current.cptKey == 'cpt-combination-page') {
            let tab = refMap[event.tabId]
            let currentIndex = tab.tabs.findIndex(t => t.value == tab.activeValue)
            let currentKey = tab.tabs[currentIndex].value
            if (value == 'prev') {
                currentIndex = currentIndex == 0 ? 0 : currentIndex - 1
                currentKey = tab.tabs[currentIndex].value
            } else if (value == 'next') {
                currentIndex = currentIndex == (tab.tabs.length - 1) ? (tab.tabs.length - 1) : currentIndex + 1
                currentKey = tab.tabs[currentIndex].value
            } else if (value == 'current') {
                let currentTabChildComp = tab.current.tabGroup[tab.activeValue]
                console.log(currentTabChildComp,'tabtabtabtab');
                for (let i = 0; i < currentTabChildComp.length; i++) {
                    const element = refMap[currentTabChildComp[i]];
                    console.log(element, 'elementelementelement');
                    element.refreshCptData && element.refreshCptData(element.current.cptOption.cptDataForm,this.paras)
                    element?.iframeReload && element.iframeReload()

                }
            }
            console.log(value, 'value');
            refMap[event.tabId].changeTab(currentKey, currentIndex)

        }


        //   if (!event) {
        //     return
        //   }
        //   let tabId = event.tabId
        //   if (tabId) {
        //     console.log(this.refMap[tabId], tabId, this.refMap, 'tab');
        //     console.log(this.options, this.newData, 'asdiohjasiojidoio');
        //     let index = this.options.findIndex(item => item.value == this.newData.value)
        //     this.refMap[tabId].changeTab(this.newData.value, index)
        //     // changeTab 
        //   }
    }

    static setCombinationPageShow(current) {

    }
}